$(".product__customization_container").click(function () {
  $("html").addClass("noscroll");
  $("body").addClass("noscroll");
  $("body").append(
    "<div class='product__customization_sidebar_overlay'></div>"
  );
  $(".product__customization_sidebar").css("transform", "translateX(0)");
});
$(".product__customization__close-sidebar").click(function () {
  $(".product__customization_sidebar").css("transform", "translateX(100%)");
  $(".product__customization_sidebar").find("input").removeClass("required");
  $(".product__customization_sidebar").find("input").removeAttr("required");
  $(".sidebar_model").css("transform", "translateX(100%)");
  $(".product__customization_sidebar_overlay").remove();
  $("html").removeClass("noscroll");
  $("body").removeClass("noscroll");

  $(".alert-danger").remove();
  $(".product__customization_sidebar input[type=radio]").attr("checked", false);
  $(
    ".product__customization_sidebar input[type=text],.product__customization_sidebar textarea,.product__customization_sidebar input[type=file]"
  ).val("");

  $(".selected_option").html("&nbsp;");
  $(".selected_option_color").html("&nbsp;");
  $(".selected_option_LogoSize").html("&nbsp;");
  $(".selected_option_logo").html("&nbsp;");
  $(".swatch-element-select").removeClass("active");
  $(".swatch-element-select-color").removeClass("active");
  $(".swatch-element-select-logo").removeClass("active");
});

$("a.select_link").click(function () {
  var data_show = $(this).attr("data-show");
  $(data_show)
    .find(".sidebar_model_carousel .carousel")
    .not(".slick-initialized")
    .slick({
      slidesToShow: 1,
      dots: true,
      adaptiveHeight: true,
      centerPadding: "0px",
    });
  $(data_show).css("transform", "translateX(0)");
  $(data_show).find("input").attr("required", "required");
  $(data_show).find("input").addClass("required");
});

$(".product__customization__back, .btnCancelAddToCart").click(function () {
  $(this).parents(".sidebar_model").css("transform", "translateX(100%)");
  $(this).parents(".sidebar_model").find("input").removeAttr("required");
  $(this).parents(".sidebar_model").find("input").removeClass("required");

  $(".alert-danger").remove();
  $(this)
    .parents(".sidebar_model")
    .find("input[type=radio]")
    .attr("checked", false);
  $(this)
    .parents(".sidebar_model")
    .find("input[type=text], textarea, input[type=file]")
    .val("");

  $(".selected_option").html("&nbsp;");
  $(".selected_option_color").html("&nbsp;");
  $(".selected_option_LogoSize").html("&nbsp;");
  $(".selected_option_logo").html("&nbsp;");
  $(".swatch-element-select").removeClass("active");
  $(".swatch-element-select-color").removeClass("active");
  $(".swatch-element-select-logo").removeClass("active");
});

$('input[type=radio][name="properties[fonts]"]').change(function () {
  $(
    ".header.select__fonts .alert-danger,.header.select__fonts_both .alert-danger"
  ).remove();
  $(".swatch-element-select").removeClass("active");
  $(this).parents(".swatch-element-select").addClass("active");
  $(".selected_option").html("&nbsp;" + this.value);
  $(".swatch-select .swatch-element-select-text input").css(
    "font-family",
    this.value
  );
});
$('input[type=radio][name="properties[color]"]').change(function () {
  $(
    ".header.select__colors .alert-danger,.header.select__colors_both .alert-danger"
  ).remove();
  $(".swatch-element-select-color").removeClass("active");
  $(this).parents(".swatch-element-select-color").addClass("active");
  $(".selected_option_color").html("&nbsp;" + this.value);
});

$('input[type=text][name="properties[text]"]').keyup(function () {
  if ($.trim($(this).val()) != "") {
    $(".header.select__text .alert-danger").remove();
  }
});
$('input[type=text][name="properties[Text]"]').keyup(function () {
  if ($.trim($(this).val()) != "") {
    $(".header.select__text_both .alert-danger").remove();
  }
});

$("#AddToCartText").click(function () {
  if (
    !$('#model_2 input[type=radio][name="properties[fonts]"]').is(":checked")
  ) {
    $(".header.select__fonts .alert-danger").remove();
    $(".select__fonts").append(
      "<p class='alert-danger'>* veuillez en sélectionner un</p>"
    );
    scrollToProduct(".select__fonts");
  } else if (
    !$('#model_2 input[type=radio][name="properties[color]"]').is(":checked")
  ) {
    $(".header.select__colors .alert-danger").remove();
    $(".select__colors").append(
      "<p class='alert-danger'>* veuillez en sélectionner un</p>"
    );
    scrollToProduct(".select__colors");
  } else if (
    $.trim($('#model_2 input[type=text][name="properties[text]"').val()) == ""
  ) {
    $(".header.select__text .alert-danger").remove();
    $(".select__text").append(
      "<p class='alert-danger'>* Ce champ est obligatoire</p>"
    );
    scrollToProduct(".select__text");
  } else {
    $("body").addClass("velaCartAdding");
    let formData = {
      items: [
        {
          id: 43301217960182,
          quantity: $(".velaQtyNum").val(),
        },
      ],
    };
    fetch(
      window.Shopify.routes.root + "cart/add.js?_easygift_apply_rules=false",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    )
      .then((response) => {
        console.log(response);
        $(".alert-danger").remove();
        $(".product__customization_sidebar").css(
          "transform",
          "translateX(100%)"
        );
        $(".product__customization_sidebar")
          .find("input")
          .removeClass("required");
        $(".product__customization_sidebar")
          .find("input")
          .removeAttr("required");
        $(".sidebar_model").css("transform", "translateX(100%)");
        $(".product__customization_sidebar_overlay").remove();
        $("html").removeClass("noscroll");
        $("body").removeClass("noscroll");
        $("form#oldID").submit();

        $(this)
          .closest(".product__customization_sidebar")
          .find("input[type=radio]")
          .attr("checked", false);
        $(this)
          .closest(".product__customization_sidebar")
          .find("input[type=text], textarea,input[type=file]")
          .val("");
        $(".selected_option").html("&nbsp;");
        $(".selected_option_color").html("&nbsp;");
        $(".selected_option_LogoSize").html("&nbsp;");
        $(".selected_option_logo").html("&nbsp;");
        $(".swatch-element-select").removeClass("active");
        $(".swatch-element-select-color").removeClass("active");
        $(".swatch-element-select-logo").removeClass("active");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});

$('input[type=radio][name="properties[Logo Size]"]').change(function () {
  $(
    ".header.select__logo_size .alert-danger,.header.select__logo_size_both .alert-danger"
  ).remove();
  $(".swatch-element-select-logo").removeClass("active");
  $(this).parents(".swatch-element-select-logo").addClass("active");
  $(".selected_option_LogoSize").html("&nbsp;" + this.value);
});

$(".swatch-element-select-logo").on(
  "change",
  'input[type=file][name="properties[logo]"]',
  function () {
    $(".header.select__logo .alert-danger").remove();
    var filename = $(this)
      .val()
      .replace(/C:\\fakepath\\/i, "");
    $(".selected_option_logo").html("&nbsp;" + filename);
  }
);

$(".swatch-element-select-logo").on(
  "change",
  'input[type=file][name="properties[Logo]"]',
  function () {
    $(".header.select__logo_both .alert-danger").remove();
    var filename = $(this)
      .val()
      .replace(/C:\\fakepath\\/i, "");
    $(".selected_option_logo").html("&nbsp;" + filename);
  }
);

$("#AddToCartLogo").click(function () {
  if (
    !$('#model_3 input[type=radio][name="properties[Logo Size]"]').is(
      ":checked"
    )
  ) {
    $(".header.select__logo_size .alert-danger").remove();
    $(".select__logo_size").append(
      "<p class='alert-danger'>* veuillez en sélectionner un</p>"
    );
    scrollToProduct(".select__logo_size");
  } else if ($.trim($("#model_3 input[type=file]").val()) == "") {
    $(".header.select__logo .alert-danger").remove();
    $(".select__logo").append(
      "<p class='alert-danger'>* Ce champ est obligatoire</p>"
    );
    scrollToProduct(".select__logo");
  } else {
    $("body").addClass("velaCartAdding");
    let formData = {
      items: [
        {
          id: 43313120313590,
          quantity: $(".velaQtyNum").val(),
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log(response);
        $(".alert-danger").remove();
        $(".product__customization_sidebar").css(
          "transform",
          "translateX(100%)"
        );
        $(".product__customization_sidebar")
          .find("input")
          .removeClass("required");
        $(".product__customization_sidebar")
          .find("input")
          .removeAttr("required");
        $(".sidebar_model").css("transform", "translateX(100%)");
        $(".product__customization_sidebar_overlay").remove();
        $("html").removeClass("noscroll");
        $("body").removeClass("noscroll");
        $("form#oldID").submit();

        $(this)
          .closest(".product__customization_sidebar")
          .find("input[type=radio]")
          .attr("checked", false);
        $(this)
          .closest(".product__customization_sidebar")
          .find("input[type=text], textarea,input[type=file]")
          .val("");
        $(".selected_option").html("&nbsp;");
        $(".selected_option_color").html("&nbsp;");
        $(".selected_option_LogoSize").html("&nbsp;");
        $(".selected_option_logo").html("&nbsp;");
        $(".swatch-element-select").removeClass("active");
        $(".swatch-element-select-color").removeClass("active");
        $(".swatch-element-select-logo").removeClass("active");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});

$("#AddToCartBoth").click(function () {
  if (
    !$('#model_4 input[type=radio][name="properties[Logo Size]"]').is(
      ":checked"
    )
  ) {
    $(".header.select__logo_size_both .alert-danger").remove();
    $(".select__logo_size_both").append(
      "<p class='alert-danger'>* veuillez en sélectionner un</p>"
    );
    scrollToProduct(".select__logo_size_both");
  } else if ($.trim($("#model_4 input[type=file]").val()) == "") {
    $(".header.select__logo_both .alert-danger").remove();
    $(".select__logo_both").append(
      "<p class='alert-danger'>* Ce champ est obligatoire</p>"
    );
    scrollToProduct(".select__logo_both");
  } else if (
    !$('#model_4 input[type=radio][name="properties[fonts]"]').is(":checked")
  ) {
    $(".header.select__fonts_both .alert-danger").remove();
    $(".select__fonts_both").append(
      "<p class='alert-danger'>* veuillez en sélectionner un</p>"
    );
    scrollToProduct(".select__fonts_both");
  } else if (
    !$('#model_4 input[type=radio][name="properties[color]"]').is(":checked")
  ) {
    $(".header.select__colors_both .alert-danger").remove();
    $(".select__colors_both").append(
      "<p class='alert-danger'>* veuillez en sélectionner un</p>"
    );
    scrollToProduct(".select__colors_both");
  } else if (
    $.trim($('#model_4 input[type=text][name="properties[Text]"').val()) == ""
  ) {
    console.log($("#model_4 input[type=text]").val());
    $(".header.select__text_both .alert-danger").remove();
    $(".select__text_both").append(
      "<p class='alert-danger'>* Ce champ est obligatoire</p>"
    );
    scrollToProduct(".select__text_both");
  } else {
    $("body").addClass("velaCartAdding");
    let formData = {
      items: [
        {
          id: 43318421782774,
          quantity: $(".velaQtyNum").val(),
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log(response);
        $(".alert-danger").remove();
        $(".product__customization_sidebar").css(
          "transform",
          "translateX(100%)"
        );
        $(".product__customization_sidebar")
          .find("input")
          .removeClass("required");
        $(".product__customization_sidebar")
          .find("input")
          .removeAttr("required");
        $(".sidebar_model").css("transform", "translateX(100%)");
        $(".product__customization_sidebar_overlay").remove();
        $("html").removeClass("noscroll");
        $("body").removeClass("noscroll");
        $("form#oldID").submit();

        $(this)
          .closest(".product__customization_sidebar")
          .find("input[type=radio]")
          .attr("checked", false);
        $(this)
          .closest(".product__customization_sidebar")
          .find("input[type=text], textarea,input[type=file]")
          .val("");
        $(".selected_option").html("&nbsp;");
        $(".selected_option_color").html("&nbsp;");
        $(".selected_option_LogoSize").html("&nbsp;");
        $(".selected_option_logo").html("&nbsp;");
        $(".swatch-element-select").removeClass("active");
        $(".swatch-element-select-color").removeClass("active");
        $(".swatch-element-select-logo").removeClass("active");
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});

function scrollToProduct(classname) {
  var element = document.querySelector(classname);
  element.scrollIntoView({ behavior: "smooth", block: "center" });
}
